import { __decorate, __metadata, __param } from "tslib";
import { injectable, optional } from "inversify";
import { TranslationCache } from "./TranslationCache";
import { TranslationStore } from "./TranslationStore";
import { TranslationProvider } from "./provider/TranslationProvider";
import { LocalizationContext } from "../context";
let TranslationService = class TranslationService {
    constructor(context, store, cache, provider) {
        this.context = context;
        this.store = store;
        this.cache = cache;
        this.provider = provider;
    }
    registerListeners() {
        this.localizationContextSubscription ??=
            this.context.value$.subscribe(ctx => this.onLocalizationContextChange(ctx));
    }
    async onLocalizationContextChange(ctx) {
        await this.refreshStore(ctx.currentLocale);
    }
    async refreshStore(newLocale) {
        const translations = await this.getTranslationsForLocale(newLocale);
        this.store.set({
            locale: newLocale,
            translations,
        });
    }
    async getTranslationsForLocale(locale) {
        const cached = this.cache.get(locale);
        if (cached)
            return cached;
        else if (this.provider) {
            const provided = await this.provider.getTranslationsForLocale(locale);
            this.cache.set(locale, provided);
            return provided;
        }
        else {
            return new Map();
        }
    }
    async getTranslation(key, locale) {
        const translations = await this.getTranslationsForLocale(locale);
        return translations.get(key);
    }
};
TranslationService = __decorate([
    injectable(),
    __param(3, optional()),
    __metadata("design:paramtypes", [LocalizationContext,
        TranslationStore,
        TranslationCache,
        TranslationProvider])
], TranslationService);
export { TranslationService };
//# sourceMappingURL=TranslationService.js.map